import React, { useState, useEffect, useContext } from "react";
import { Link, navigate } from "gatsby";
import { useMutation } from "@apollo/client";
import { NEW_USER } from "../mutations";
import { toast } from "react-toastify";
import client from "../apollo/client";
import { FilterContext } from "../context/FilterContext";
import textileLibraryLogo from "../images/textile_library_logo.png";
import { tokenMail } from "../services/appenv";
import { sendMailPreRegister } from "../services/api";

const emailRegex =
  /^(([^<>()[\],;:\s@"]+([^<>()[\],;:\s@"]+)*)|(".+"))@(([^<>()[\],;:\s@"]+)+[^<>()[\],;:\s@"]{2,})$/i;

const RegisterNew = () => {
  const { setDataProductsFilter, setTempDataFilter } =
    useContext(FilterContext);

  const generateRandomPassword = () => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
    let password = "";
    for (let i = 0; i < 12; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  };

  const [register, setRegister] = useState({
    firstname: "",
    lastname: "",
    companyName: "",
    email: "",
    messageError: {},
  });

  const { messageError } = register;

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      navigate("/products");
    } else {
      client.clearStore();
      localStorage.removeItem("token");
    }

    return () => {
      setDataProductsFilter([]);
      setTempDataFilter([]);
    };
  }, [setDataProductsFilter, setTempDataFilter]);

  const formValidate = (errors, formData) => {
    const hasErrors = Object.values(errors).some((error) => error);

    const requiredFields = ["firstname", "lastname", "email"];
    const hasEmptyFields = requiredFields.some(
      (field) => !formData[field]?.trim()
    );

    return !hasErrors && !hasEmptyFields;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim();
    let errors = { ...register.messageError };

    switch (name) {
      case "firstname":
        errors.firstname = !trimmedValue ? "This field is required" : "";
        break;
      case "lastname":
        errors.lastname = !trimmedValue ? "This field is required" : "";
        break;
      case "email":
        if (!trimmedValue) {
          errors.email = "This field is required";
        } else if (!emailRegex.test(trimmedValue)) {
          errors.email = "This is not a valid email";
        } else {
          errors.email = "";
        }
        break;
      default:
        break;
    }

    setRegister((prevState) => ({
      ...prevState,
      [name]: value,
      messageError: errors,
    }));
  };

  const handleSendEmail = async () => {
    try {
      const dataPreRegister = {
        email: register.email,
        firstName: register.firstname,
        lastName: register.lastname,
        companyName: register.companyName,
        registrationform: "pre",  
      };
      await sendMailPreRegister(dataPreRegister, tokenMail);
    } catch (error) {}
  };

  // Register user mutation
  const [addUser] = useMutation(NEW_USER, {
    onCompleted: () => {
      toast.success("Your registration was completed successfully.");
      handleSendEmail();

      // Reset form
      setRegister({
        firstname: "",
        lastname: "",
        companyName: "",
        email: "",
        messageError: {},
      });

      navigate("/after-register");
    },
    onError: (error) => {
      toast.error(
        "There was a problem registering, or the user already exists."
      );
    },
  });

  const handleRegisterUser = () => {
    const randomPassword = generateRandomPassword();

    addUser({
      variables: {
        data: {
          firstName: register.firstname,
          lastName: register.lastname,
          password: randomPassword,
          username: register.email,
          email: register.email,
          companyName: register.companyName,
          role: 1,
          confirmed: false,
          user_type: 5,
          blocked: true,
        },
      },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formValidate(register.messageError, register)) {
      handleRegisterUser();
    } else {
      toast.error("Please complete the form correctly");
    }

    e.target.reset();
  };

  return (
    <div className="home-flex-content">
      <div className="home-page">
        <div className="home-page__text">
          <img src={textileLibraryLogo} alt="Textile Library Logo" />
          <h3>TEXTILE LIBRARY by Takihyo Coming Soon!</h3>
          <p>Pre-register for news and updates regarding the site!</p>
        </div>

        <form noValidate className="home-page__form" onSubmit={handleSubmit}>
          <div className="u-position-relative">
            <input
              type="email"
              name="email"
              value={register.email}
              onChange={handleChange}
              onBlur={handleChange}
              className={messageError.email ? "border-error" : ""}
              placeholder="Email Address *"
              required
            />
            {messageError.email && (
              <small className="field-error field-error-home">
                {messageError.email}
              </small>
            )}
          </div>

          <div className="u-position-relative">
            <input
              type="text"
              name="companyName"
              value={register.companyName}
              onChange={handleChange}
              onBlur={handleChange}
              placeholder="Company / Brand Name"
            />
          </div>

          <div className="fields-group-name-lastname">
            <div className="u-position-relative">
              <input
                type="text"
                name="firstname"
                value={register.firstname}
                onChange={handleChange}
                onBlur={handleChange}
                className={messageError.firstname ? "border-error" : ""}
                placeholder="First Name *"
                required
              />
              {messageError.firstname && (
                <small className="field-error field-error-home">
                  {messageError.firstname}
                </small>
              )}
            </div>

            <div className="u-position-relative">
              <input
                type="text"
                name="lastname"
                value={register.lastname}
                onChange={handleChange}
                onBlur={handleChange}
                className={messageError.lastname ? "border-error" : ""}
                placeholder="Last Name *"
                required
              />
              {messageError.lastname && (
                <small className="field-error field-error-home">
                  {messageError.lastname}
                </small>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="u-text-uppercase btn btn-primary btn-submit"
          >
            Submit
          </button>
        </form>

        <p className="home-page__link">
          <Link to="/login">LOGIN</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterNew;
